import styled from 'styled-components';

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    min-height: 600px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 25px;
    box-sizing: border-box;
    background-color: ${({ $dark }) => ($dark ? 'rgba(21, 24, 29, 0.65)' : 'rgba(255, 255, 255, 0.9)')};
    border-radius: 15px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    border: ${({ $dark }) => ($dark ? '1px solid rgba(71, 85, 105, 0.4)' : 'none')};
`;

export const ActionsContainer = styled.div`
    display: flex;
    flex-direction: row;
    bottom: 0;
    width: 100%;
    padding-top: 45px;
    box-sizing: border-box;
`;

export const UserTextInput = styled.textarea`
    width: calc(100% - 60px);
    height: 85px;
    border-radius: 15px;
    background-color: ${({ $dark }) => ($dark ? 'rgba(30, 41, 59, 0.9)' : 'rgba(255, 255, 255, 0.8)')};
    color: ${({ $dark }) => ($dark ? '#e2e8f0' : 'inherit')};
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    border: 2px solid ${({ $dark }) => ($dark ? 'rgba(71, 85, 105, 0.5)' : 'transparent')};
    padding: 15px 20px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: 'Inter';
    text-align: left;
    margin: 0;
    transition: border 0.3s ease;
    line-height: 1.7;

    &::placeholder {
        color: ${({ $dark }) => ($dark ? '#64748b' : '#999')};
    }

    &:focus {
        outline: none;
        border: 2px solid #64B5F6;
    }
`;

export const SendMessageButton = styled.button`
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: #0D47A1;
    }
    &:active {
        box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
    }
`;

export const BotIntroduction = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
    margin-top: 25px;

    img {
        width: 140px;
        height: 140px;
    }

    @keyframes float {
        0%, 100% {
            transform: translateY(0);
        }
        50% {
            transform: translateY(-10px);
        }
    }

    p {
        font-size: 18px;
        font-family: 'Inter';
        font-weight: 500;
        text-align: center;
        color: ${({ $dark }) => ($dark ? '#e2e8f0' : '#263238')};
        line-height: 1.8;
        max-width: 400px;
    }
`;

export const HistoryMessages = styled.div`
    width: 100%;
    max-height: 450px;
    overflow-y: auto;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    /* Scrollbar styling (dark) */
    scrollbar-width: thin;
    scrollbar-color: rgba(148, 163, 184, 0.7) rgba(15, 23, 42, 0.5);

    &::-webkit-scrollbar {
        width: 10px;
    }

    &::-webkit-scrollbar-track {
        background: rgba(15, 23, 42, 0.5);
        border-radius: 999px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(148, 163, 184, 0.6);
        border-radius: 999px;
        border: 2px solid rgba(15, 23, 42, 0.5);
    }

    &::-webkit-scrollbar-thumb:hover {
        background: rgba(148, 163, 184, 0.8);
    }
`;

export const UserMessageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: 450px;
    align-self: flex-end;
    animation: slideFromBottom 1s ease-out forwards;

    @keyframes slideFromBottom {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    &.loading {
        p {
            opacity: 0.4;
            filter: blur(2px);
        }
        span {
            display: none;
        }
    }

    p {
        font-size: 14px;
        font-family: 'Google Sans';
        font-weight: 400;
        text-align: left;
        color:rgb(46, 46, 46);
        margin-bottom: 5px;
        line-height: 1.7;
        background-color: rgba(255,255,255,0.2);
        padding: 17px 25px;
        border-radius: 15px;
        border-top-right-radius: 0;
    }

    span {
        font-size: 10px;
        font-family: 'Inter';
        font-weight: 400;
        text-align: left;
        color: ${({ $dark }) => ($dark ? '#94a3b8' : '#999')};
        margin-bottom: 10px;
        line-height: 1.7;
        padding-left: 20px;
    }
`;

export const BotMessageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: 450px;
    align-self: flex-start;
    animation: slideFromBottom 1s ease-out forwards;

    @keyframes slideFromBottom {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    &.loading {
        p {
            opacity: 0.4;
            filter: blur(2px);
        }
        span {
            display: none;
        }
    }

    p {
        font-size: 14px;
        font-family: 'Inter';
        font-weight: 400;
        text-align: left;
        color: ${({ $dark }) => ($dark ? '#e2e8f0' : '#212121')};
        margin-bottom: 5px;
        line-height: 1.7;
        background-color: ${({ $dark }) => ($dark ? 'rgba(51, 65, 85, 0.8)' : '#E3F2FD')};
        padding: 17px 25px;
        border-radius: 15px;
        border-top-left-radius: 2px;
    }

    span {
        font-size: 10px;
        font-family: 'Inter';
        font-weight: 400;
        text-align: left;
        color: ${({ $dark }) => ($dark ? '#94a3b8' : '#999')};
        margin-bottom: 10px;
        line-height: 1.7;
        padding-left: 20px;
    }
`;

export const BotLoadingMessage = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    height: 50px;
    animation: slideFromBottom 1s ease-out forwards;
    margin-top: 10px;

    @keyframes slideFromBottom {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    #spinner {
        animation: spin 1s linear infinite;
        color: ${({ $dark }) => ($dark ? '#94a3b8' : '#999')};
    }
    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }

    span {
        font-size: 14px;
        font-family: 'Inter';
        font-weight: 400;
        text-align: left;
        color: ${({ $dark }) => ($dark ? '#94a3b8' : '#999')};
    }
`;